import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import './App.css';
import './admin.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import AdminLayout from './layout/AdminLayout';
import Login from './pages/Login';
import Services from './pages/Services';
import BillingsCustomers from './pages/BillingsCustomers';
import Projects from './pages/Projects';
import CanvasDespatch from './pages/CanvasDespatch';
import SystemAccess from './pages/SystemAccess';
import CanvasLibrary from './pages/CanvasLibrary';
import QrPayment from './pages/QrPayment';
import CampaignPage from './pages/public/CampaignPage';
import SubmitMessagePage from './pages/public/SubmitMessagePage';
import HomePage from './pages/public/HomePage';
import PaymentPage from './pages/public/PaymentPage';
import ThankYouPage from './pages/public/ThankYouPage';

function AdminArea() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="admin-shell" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p>Checking access…</p>
      </div>
    );
  }
  return user ? children : <Navigate to="/admin/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/pay" element={<PaymentPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />

        <Route path="/services" element={<Navigate to="/admin/services" replace />} />
        <Route path="/billings" element={<Navigate to="/admin/billings" replace />} />
        <Route path="/projects" element={<Navigate to="/admin/projects" replace />} />
        <Route path="/canvas-despatch" element={<Navigate to="/admin/canvas-despatch" replace />} />
        <Route path="/canvas-library" element={<Navigate to="/admin/canvas-library" replace />} />
        <Route path="/system-access" element={<Navigate to="/admin/system-access" replace />} />
        <Route path="/qr-payment" element={<Navigate to="/admin/qr-payment" replace />} />

        <Route element={<AdminArea />}>
          <Route path="/login" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<Login />} />
          <Route
            path="/admin"
            element={(
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            )}
          >
            <Route index element={<Navigate to="/admin/services" replace />} />
            <Route path="services" element={<Services />} />
            <Route path="billings" element={<BillingsCustomers />} />
            <Route path="projects" element={<Projects />} />
            <Route path="canvas-despatch" element={<CanvasDespatch />} />
            <Route path="canvas-library" element={<CanvasLibrary />} />
            <Route path="qr-payment" element={<QrPayment />} />
            <Route path="system-access" element={<SystemAccess />} />
          </Route>
        </Route>

        <Route path="/:domain" element={<CampaignPage />} />
        <Route path="/:domain/submit" element={<SubmitMessagePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
